import { cloneDeep, pick } from 'lodash'

import { EMPTY_SENDINGS } from '@sigma-legacy-libs/essentials/lib/constants'

const fields = [ 'type', 'payload', '$options' ]
export const getEmptyFallback = () => pick(cloneDeep(EMPTY_SENDINGS), fields)
